/*
 * The bridge in the running app: window messages in, the app's state and
 * actions behind it (bridge.ts has the rules).
 */
import { effect } from "@preact/signals";
import { CORE_VERSION } from "../core/core";
import * as S from "../ui/state";
import { Activation, Bridge, BridgeStatus } from "./bridge";

export function startBridge(origins: string[]): Bridge | null {
  if (!origins.length) {
    console.warn("MocTel Vox: framed, but config.json has no embed_origins: the host page cannot drive the phone");
    return null;
  }
  const bridge = new Bridge(
    origins,
    {
      status: status,
      calls: () => S.calls.value,
      dial: (to, ref) => S.dialNumber(to, ref),
      answer: (call) => S.answer(call),
      // a ringing call is declined, as with the phone's own button
      hangup: (call) => (S.calls.value.find((c) => c.call === call)?.state === "incoming" ? S.decline(call) : S.hangup(call)),
      hold: (call, on) => S.hold(call, on),
      mute: (call, on) => S.mute(call, on),
      dtmf: (call, digits) => S.dtmf(call, digits),
      transfer: (call, to) => S.cmd({ cmd: "call.transfer", call, to }),
      dnd: (enable) => S.setPrefs({ dnd: enable }),
      activate: (token) => S.activateWithToken(token),
      contactName: (number) => S.contactFor(number)?.name,
    },
    (msg, origin) => window.parent.postMessage(msg, origin),
  );
  addEventListener("message", (e) => void bridge.onMessage(e.data, e.origin, e.source === window.parent));
  S.coreListeners.add((e) => bridge.onCoreEvent(e));
  // status follows the signals it reads
  effect(() => {
    status();
    bridge.status();
  });
  return bridge;
}

function status(): BridgeStatus {
  const activation: Activation = !S.setupNeeded.value ? "active" : S.provState.value === "enrolling" ? "activating" : "needed";
  return {
    activation,
    line: S.registration.value as BridgeStatus["line"],
    dnd: S.prefs.value.dnd,
    version: CORE_VERSION,
  };
}
